import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_user = (
  user_id,
  username,
  password,
  email,
  phone,
  role,
  status,
  balance
) => {
  return api.post(`${ApiEndpointConstants.ADD_USER}`, {
    user_id,
    username,
    password,
    email,
    phone,
    role,
    status,
    balance,
  });
};
